<template>
  <section>
    <b-container fluid>
      <b-row class="justify-content-center introduction">
        <b-col
          cols="11"
          sm="10"
          md="9"
          xl="8"
          class="flex-column justify-content-center d-flex"
        >
          <!-- 关于我们 -->
          <div class="jian">
            <v-com_title :msg="hTitle[0]"></v-com_title>
            <b-container fluid>
              <b-row class="justify-content-center">
                <b-col
                  cols="12"
                  md="8"
                  lg="9"
                  class="flex-column justify-content-center d-flex content"
                >
                  <p style="text-align: justify">
                    中国民用航空局信息中心作为中国民用航空局直属事业单位，自2006年诞生伊始便承担起以行业信息化建设助力民航强国的重担，不忘初心，牢记使命，主动对接新时代民航强国战略，以推进民航行业治理体系和治理能力现代化为主轴，聚焦中国民航信息化、智能化发展的前沿需求，借助蓬勃兴起的新理论、新技术、新方法，探索“智慧民航”新形态、打造信息时代民航发展新动能、助力民航的智慧化建设和可持续发展。
                  </p>
                  <!-- <b-col
                    cols="12"
                    md="4"
                    lg="3"
                    class="d-block d-md-none  flex-column justify-content-center d-flex logo-content1"
                  > -->
                  <b-img
                    src="@/assets/images/index/icon-logo.png"
                    alt=""
                    class="d-block d-md-none logo-img1 logo-content1"
                  ></b-img>
                  <!-- </b-col> -->
                </b-col>
                <b-col
                  cols="12"
                  md="4"
                  lg="3"
                  class="d-none d-md-block flex-column justify-content-center logo-content"
                >
                  <img
                    src="@/assets/images/index/icon-logo.png"
                    alt=""
                    class="logo-img"
                  />
                </b-col>
              </b-row>
            </b-container>
          </div>
          <!-- 新闻动态 -->
          <div class="dong">
            <v-com_title :msg="hTitle[1]"></v-com_title>

            <b-container fluid>
              <div
                class="more"
                style="text-align: right; margin: 0 2.5% 1% 0; cursor: pointer"
                @click="goMore"
              >
                More >>
              </div>
              <b-row class="d-flex justify-content-between">
                <!-- style="background: #ccc;" -->
                <b-col
                  cols="12"
                  sm="6"
                  xl="4"
                  class="flex-column justify-content-center d-flex newsItem"
                  v-for="(item, index) in newsData.slice(0, 3)"
                  :key="index"
                >
                  <figure
                    class="figure"
                    @click="goDetail(item)"
                    style="cursor: pointer"
                  >
                    <b-img
                      :src="item.img"
                      fluid-grow
                      class="figure-img img-fluid"
                      style="height: 70%;object-fit: cover;"
                      alt=""
                    ></b-img>
                    <!-- <img :src="item.img"   class="figure-img1 img-fluid" alt="" ></img> -->
                    <figcaption
                      class="figure-caption news-title"
                      style="text-align: justify"
                    >
                      {{ item.name }}
                    </figcaption>
                    <figcaption class="figure-caption">
                      <b-row class="d-flex align-items-center">
                        <b-col class="new-releaseTime">{{ item.time }}</b-col>
                        <b-col class="text-right news-go">
                          <!-- <img
                            src="../../../assets/images/index/arrow.png"
                            alt=""
                          /> -->
                        </b-col>
                      </b-row>
                    </figcaption>
                  </figure>
                </b-col>
              </b-row>
            </b-container>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>
<script>
import Com_title from "../com-title";
import qs from "qs";
import axios from "axios";
import utils from "@/utils/commonUrl.js";
export default {
  inject: ["reload"],
  components: {
    "v-com_title": Com_title,
  },
  data() {
    return {
      hTitle: ["关于我们", "新闻动态"],
      newsData: [],
      queryInfo: {
        currentPage: 1,
        pageSize: 10,
      },
    };
  },
  watch: {},
  created() {
    this.getNewsList();
    // this.getNewsData();
  },
  mounted() {},
  methods: {
    async getNewsList() {
      try {
        const { data: res } = await this.$http.get(
          "/server/api/content/news/website/search/getPageList",
          {
            params: this.queryInfo,
          }
        );

        if (res.code == 200) {
          this.newsData = res.content.list;
          this.newsData.forEach((item, index) => {
            item.time = this.formate_Date(item.time);
            item.img =
              utils.imgURL +
              "/server/api/system/file/getFile?id=" +
              item.fileCoverId;
          });
        }
      } catch (e) {
        return false;
      }
    },
    getNewsData() {
      this.newsData = [
        {
          id: "1",
          title: "民航局信息中心党支部联合组织开展“四史”专题学习培训",
          releaseTime: "2021-12-03",
          img: require("@/assets/images/index/news1.png"),
        },
        {
          id: "2",
          title: "柳芳赴民航局信息中心调研",
          releaseTime: "2021-12-01",
          img: require("@/assets/images/index/news2.png"),
        },
        {
          id: "3",
          title: "适航审定运行管理系统顺利通过项目终验评审",
          releaseTime: "2021-11-08",
          img: require("@/assets/images/index/news3.png"),
        },
      ];
    },
    goMore() {
      this.$router.push({
        path: "/about-us/new-center",
      });
    },
    goDetail(val) {
      if (!val.url) {
        let routeData = "";
        routeData = this.$router.resolve({
          path: `/about-us/new-detail`,
          query: {
            id: val.id,
            type: this.activeName,
          },
        });
        window.open(routeData.href, "_blank");
      } else {
        let urlStr = "";
        urlStr = val.url.indexOf("http") == -1 ? "https://" + val.url : val.url;
        window.open(urlStr);
      }
    },
    formate_Date(time) {
      time = new Date(time);
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();

      if (month < 10) {
        month = "0" + month;
      }

      if (day < 10) {
        day = "0" + day;
      }
      return year + "-" + month + "-" + day + "";
    },
  },
};
</script>
<style lang="less" scoped>
.figure {
  width: 100%;
  max-height: 300px;
  min-height: 300px;
}
.figure-img1 {
  width: 100%;
}
.figure-caption {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.introduction .content {
  position: relative;
}
.logo-content1 {
  position: absolute;
  left: 50%;
  top: 10%;
  transform: translateX(-50%);
}
.introduction .logo-img1 {
  /* width: 40%; */
  height: 70%;
}
.introduction .logo-img {
  margin-top: 10%;
  height: 85%;
}
.new-releaseTime {
  font-family: "PingFang Bold";
}
@media (max-width: 575px) {
  .introduction {
    height: auto;
  }

  .content p {
    font-size: 15px;
    line-height: 30px;
    margin: 2% 0% 5% 0;
  }

  .more {
    font-size: 15px;
  }
  .newsItem .news-title {
    font-size: 16px;
  }
  .newsItem .new-releaseTime {
    font-size: 12px;
  }
  .newsItem .news-go {
    line-height: 1.571;
  }
  .newsItem {
    padding: 2% 5%;
  }
}

/* // Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767px) {
  .introduction {
    height: auto;
  }
  /* .introduction .logo-img {
    width: 21%;
  } */

  /* .introduction .logo-img1 {
    width: 30%;
  } */
  /* .introduction {
    height: auto;
  } */

  .content p {
    font-size: 16px;
    line-height: 34px;
  }
  .more {
    font-size: 16px;
  }
  .newsItem .news-title {
    font-size: 16px;
  }
  .newsItem .new-releaseTime {
    font-size: 12px;
  }
  .newsItem .news-go {
    line-height: 1.571;
  }
  .newsItem:nth-child(odd) {
    padding-right: 5%;
  }
  .newsItem:nth-child(even) {
    padding-left: 5%;
  }
}

/* // Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991px) {
  .introduction {
    height: auto;
  }

  .content p {
    font-size: 16px;
    line-height: 32px;
  }
  .more {
    font-size: 16px;
  }
  .newsItem .news-title {
    font-size: 15px;
  }
  .newsItem .new-releaseTime {
    font-size: 12px;
  }
  .newsItem .news-go {
    line-height: 1.571;
  }
  .newsItem:nth-child(odd) {
    padding-right: 5%;
  }
  .newsItem:nth-child(even) {
    padding-left: 5%;
  }
}

/* // Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199px) {
  /* .introduction .logo-img {
    width: 80%;
  } */

  .content p {
    font-size: 16px;
    line-height: 34px;
  }
  .introduction {
    height: auto;
  }
  .more {
    font-size: 16px;
  }
  .newsItem .news-title {
    font-size: 16px;
  }
  .newsItem .new-releaseTime {
    font-size: 13px;
  }

  .newsItem .news-go {
    line-height: 1.571;
  }
  .figure-img1 {
    width: 100%;
    height: 185px;
  }
  .newsItem:nth-child(odd) {
    padding-right: 5%;
  }
  .newsItem:nth-child(even) {
    padding-left: 5%;
  }
}

/* // Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) and (max-width: 1600px) {
  .introduction {
    height: auto;
  }
  .figure-img1 {
    width: 100%;
    height: 185px;
  }
  .newsItem:nth-child(1) {
    padding-right: 4%;
  }
  .newsItem:nth-child(2) {
    padding: 0 2%;
  }
  .newsItem:nth-child(3) {
    padding-left: 4%;
  }
  .introduction .logo-img {
    /* min-width: 60%; */
  }
}
@media (min-width: 1600px) and (max-width: 1980px) {
  .introduction {
    height: auto;
  }
  .figure-img1 {
    width: 100%;
    height: 185px;
  }
  .newsItem:nth-child(1) {
    padding-right: 5%;
  }
  .newsItem:nth-child(2) {
    padding: 0 2.5%;
  }
  .newsItem:nth-child(3) {
    padding-left: 5%;
  }
  .introduction .logo-img {
    /* min-width: 60%; */
  }
}
@media (min-width: 1981px) and (max-width: 2048px) {
  .introduction {
    height: auto;
  }
  .figure {
    width: 100%;
    height: 100%;
    /* background-color: #fcc; */
  }
  .figure-img1 {
    width: 100%;
    height: 210px;
  }
  .newsItem:nth-child(1) {
    padding-right: 7%;
  }
  .newsItem:nth-child(2) {
    padding: 0 3.5%;
  }
  .newsItem:nth-child(3) {
    padding-left: 7%;
  }
  .introduction .logo-img {
    /* min-width: 60%; */
  }
}
@media (min-width: 2049px) and (max-width: 3000px) {
  .introduction {
    height: auto;
  }
  .figure {
    width: 100%;
    height: 100%;
  }
  .figure-img1 {
    width: 100%;
    height: 210px;
  }
  .newsItem:nth-child(1) {
    padding-right: 8%;
  }
  .newsItem:nth-child(2) {
    padding: 0 4%;
  }
  .newsItem:nth-child(3) {
    padding-left: 8%;
  }
  .introduction .logo-img {
  }
}
@media (min-width: 3001px) {
  .introduction {
    height: auto;
  }
  .figure {
    width: 100%;
    height: 100%;
  }
  .figure-img1 {
    width: 100%;
    height: 210px;
  }
  .newsItem:nth-child(1) {
    padding-right: 10%;
  }
  .newsItem:nth-child(2) {
    padding: 0 5%;
  }
  .newsItem:nth-child(3) {
    padding-left: 10%;
  }
  .introduction .logo-img {
  }
}
</style>
